import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from './../../shared/services/api.service';
import { AppointmentCalendar } from './../../models/calendar/calendar.model';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import * as moment from 'moment';
import { DataUtils } from './../../shared/utils/data-utils';

@Component({
  selector: 'swb-appointments-overview',
  templateUrl: './appointments-overview.component.html'
})
export class AppointmentsOverviewComponent implements OnInit, OnDestroy {

  private _id: number;
  private _pikaday: any;
  private _date = moment().utc();

  public get id(): number {
    return this._id;
  }

  public isInitialized = false;

  public calendar: AppointmentCalendar;

  public get date(): Date {
    return this._date.toDate();
  }

  public loading = true;

  public days: Array<moment.Moment>;

  constructor(
    private _apiService: ApiService,
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  public ngOnInit(): void {
    this.init();
    this._router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.init();
      }
    });
  }

  public init() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
      this._getEntity();
    }
  }

  private _getEntity() {
    this.loading = true;
    this._apiService.get(
      'appointment-calendars' + '/' + this._id + '/' + this._date.clone().month() + '/' + this._date.clone().year()
    )
      .subscribe(
        (response: any) => {
          this.days = new Array(this._date.clone().daysInMonth()).fill(null).map((x, i) =>
            this._date.clone().startOf('month').add(i, 'days'));
          this.calendar = { ...response }.data;

          this.loading = false;

        },
        (error) => console.error(error)
      );
  }

  public ngOnDestroy(): void {
    delete this._pikaday;
  }

  public getTitle(titleObject: any): string {
    return DataUtils.getTitle(titleObject);
  }

  public getTranslated(object: any, key: string): string {
    return DataUtils.getTranslated(object, key);
  }

  public prev(): void {
    this._date.subtract(1, 'month');
    this._getEntity();
  }

  public next(): void {
    this._date.add(1, 'month');
    this._getEntity();
  }

}
